// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"d1e17e06","147":"bebbd366","228":"1ba1ce18","272":"8ec62dfe","287":"a12365f6","352":"9645a0e4","549":"791931f4","666":"b2c655b9","816":"06fd1255","837":"fa675782","930":"2dadf3ab"}[chunkId] + ".chunk.js";
};